import React from 'react';
import { PrimeReactProvider } from 'primereact/api';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import './styles/main.scss';
import People from './pages/People';
import 'primeicons/primeicons.css';
import Waste from './pages/Waste';
import SeparatedWaste from './pages/SeparatedWaste';
import HouseDetail from './pages/HouseDetail';
import Vehicle from './pages/Vehicle';
import Personel from './pages/Personel';
import Summary from './pages/Summary';
import Neighborhood from './pages/Neighborhood';
import "primereact/resources/themes/viva-light/theme.css";
import "primereact/resources/primereact.css";
import QRControl from './pages/QRControl';
import Gruplar from './pages/Groups';
import Ayarlar from './pages/Settings';
import Talepler from './pages/Requests';
import AddressAssigments from './pages/AddressAssigments';
import Duty from './pages/Duty';
import BlockedAddresses from './pages/BlockedAddresses';
import TalepKategorileri from './pages/RequestCategories';
import RoutePlans from './pages/RoutePlans';
import Popups from './pages/Popups';
import Sss from './pages/Sss';
import WastePool from './pages/Wastepool';
import AddressList from './pages/AddressList';
import HimQuery from './pages/HimQuery';
import GunlukIsTakip from './pages/GunlukIsTakip';
import Duyurular from './pages/Duyurular';
import Raporlama from './pages/Raporlama';
import MahalleAnalizi from './pages/MahalleAnalizi';
import PersonelKonumBatarya from './pages/PersonelKonumBatarya';

function App() {
  return (
    <PrimeReactProvider>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Layout />
                </PrivateRoute>
              }
            >
              <Route path="summary" element={<Summary />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="kisiler" element={<People />} />
              <Route path="vasita" element={<Vehicle />} />
              <Route path="qr-codes" element={<div>QR Codes Page</div>} />
              <Route path="ayristirma" element={<SeparatedWaste />} />
              <Route path="atik-verisi" element={<Waste />} />
              <Route path="ayristirma-detay" element={<HouseDetail />} />
              <Route path="personel" element={<Personel />} />
              <Route path="mahalle" element={<Neighborhood />} />
              <Route index element={<Navigate to="/summary" replace />} />
              <Route path="/qr-kontrol" element={<QRControl />} />
              <Route path="/gruplar" element={<Gruplar />} />
              <Route path="/adresatamalari" element={<AddressAssigments />} />
              <Route path="/gorevler" element={<Duty />} />
              <Route path="/engellenen-adresler" element={<BlockedAddresses />} />
              <Route path="/talepler" element={<Talepler />} />
              <Route path="/talep-kategorileri" element={<TalepKategorileri />} />
              <Route path="/Ayarlar" element={<Ayarlar />} />
              <Route path="/gorev-planlari" element={<RoutePlans />} />
              <Route path="/sss" element={<Sss />} />
              <Route path="/popup" element={<Popups />} />
              <Route path="/wastepool" element={<WastePool />} />
              <Route path="/adresler" element={<AddressList />} />
              <Route path="/him-kayit-sorgulama" element={<HimQuery />} />
              <Route path="/gunluk-is-takip" element={<GunlukIsTakip />} />
              <Route path="/bildirimler" element={<Duyurular />} />
              <Route path="/raporlama" element={<Raporlama />} />
              <Route path="/mahalle-analizi" element={<MahalleAnalizi />} />
              <Route path="/personel-konum-batarya" element={<PersonelKonumBatarya />} />
            </Route>
          </Routes>
        </Router>
      </AuthProvider>
    </PrimeReactProvider>
  );
}

export default App;
